import { atom } from 'recoil';

export const authState = atom({
    key: 'authState', // 고유한 key 값 설정
    default: {
        isLoggedIn: false,
        user: null,
        token: null,
    },
});
